export const TOOL_TASK = 'update-admin-role';
export const TOOL_TITLE = 'Update Admin Role';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once updating admin role finishes';
export const FILE_NAME = 'Update-admin-role-report';
export const FILE_HEADERS = {
    userId: 'User ID',
    userEmail: 'Email',
    oldRoleId: 'Old Role ID',
    oldRoleName: 'Old Role Name',
    newRoleId: 'New Role ID',
    newRoleName: 'New Role Name',
    actionStatus: 'Action Status',
};

export const TOOL_PROGRESS_LABEL = 'Bulk admin role updating progress...';

export const ROLE_MODAL_TITLES = {
    ASSIGN: 'Assign To Role',
    UPDATE: 'Update Role Members',
    UNASSIGN: 'Unassign From Role',
};

